import Lookup from 'src/componentes/select2';
import SvgIcon from 'src/componentes/svg-icon';

const FarolAcaoLookup = ({ showDescription = true, ...props }) => {
  const handleNome = (item) => {
    return (
      item &&
      item.data &&
      item.data && (
        <span>
          <SvgIcon
            icon={item.data.icone}
            size={18}
            color={item.data.cor}
            colorHover={item.data.cor}
            className="mr-2"
          ></SvgIcon>
          {showDescription && <span>{item.data.descricao}</span>}
        </span>
      )
    );
  };

  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/FarolAcaoLookup"
      clearable={false}
      valueComponent={handleNome}
      {...props}
    />
  );
};

export default FarolAcaoLookup;
